// src/pages/user/Transactions.js
import React from "react";
import StoreTransactions from "../../components/Store/StoreTransactions";

export default function StoreTransactionsPage() {
  return <StoreTransactions />;
}
